module.exports = [
  {
    "AgeGroup": "45-54 years",
    "Geography": "Metro New Orleans",
    "Year": "1999-2001",
    "Rate": 577.4
  },
  {
    "AgeGroup": "45-54 years",
    "Geography": "Metro New Orleans",
    "Year": "2002-2004",
    "Rate": 589.1
  },
  {
    "AgeGroup": "45-54 years",
    "Geography": "Metro New Orleans",
    "Year": "2005-2007",
    "Rate": 570.6
  },
  {
    "AgeGroup": "45-54 years",
    "Geography": "Metro New Orleans",
    "Year": "2008-2010",
    "Rate": 524
  },
  {
    "AgeGroup": "45-54 years",
    "Geography": "Metro New Orleans",
    "Year": "2011-2013",
    "Rate": 507.77
  },
  {
    "AgeGroup": "45-54 years",
    "Geography": "Metro New Orleans",
    "Year": "2014-2016",
    "Rate": 507.93
  },
  {
    "AgeGroup": "45-54 years",
    "Geography": "Metro New Orleans",
    "Year": "2017-2018",
    "Rate": 491.7
  },
  {
    "AgeGroup": "45-54 years",
    "Geography": "United States",
    "Year": "1999-2001",
    "Rate": 423.5
  },
  {
    "AgeGroup": "45-54 years",
    "Geography": "United States",
    "Year": "2002-2004",
    "Rate": 430.3
  },
  {
    "AgeGroup": "45-54 years",
    "Geography": "United States",
    "Year": "2005-2007",
    "Rate": 426.57
  },
  {
    "AgeGroup": "45-54 years",
    "Geography": "United States",
    "Year": "2008-2010",
    "Rate": 414.93
  },
  {
    "AgeGroup": "45-54 years",
    "Geography": "United States",
    "Year": "2011-2013",
    "Rate": 407.1
  },
  {
    "AgeGroup": "45-54 years",
    "Geography": "United States",
    "Year": "2014-2016",
    "Rate": 404.77
  },
  {
    "AgeGroup": "45-54 years",
    "Geography": "United States",
    "Year": "2017-2018",
    "Rate": 398.7
  }
]
